import styled from 'styled-components';
import { MoonIcon, SunIcon } from '../assets';
export const IconWrapper = styled.div `
  z-index: 1;
  width: 4rem;
  height: 4rem;

  display: flex;
  align-items: center;
  justify-content: center;
`;
export const CustomSunIcon = styled(SunIcon) `
  width: 2.4rem;
  height: 2.4rem;
`;
export const CustomMoonIcon = styled(MoonIcon) `
  width: 2.4rem;
  height: 2.4rem;
`;
//# sourceMappingURL=styles.js.map